export const formatCPF = (
  value: string,
  setStateFunction: (value: string) => void
) => {
  const onlyNumbers = value.replace(/\D/g, "").slice(0, 11);

  const formattedValue = onlyNumbers
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");

  setStateFunction(formattedValue);
};

export const formatTelefone = (
  value: string,
  setStateFunction: (value: string) => void
) => {
  const onlyNumbers = value.replace(/\D/g, "").slice(0, 11);

  let formattedValue = onlyNumbers;

  if (onlyNumbers.length <= 2) {
    formattedValue = onlyNumbers;
  } else if (onlyNumbers.length <= 6) {
    formattedValue = `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2)}`;
  } else if (onlyNumbers.length <= 10) {
    formattedValue = `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(
      2,
      6
    )}-${onlyNumbers.slice(6)}`;
  } else {
    formattedValue = `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(
      2,
      7
    )}-${onlyNumbers.slice(7)}`;
  }

  setStateFunction(formattedValue);
};

export function parseDecimal(value: unknown): number | null {
  if (value == null) return null;
  if (typeof value === "number") return value;

  let s = String(value).trim();
  if (s === "") return null;

  // remove qualquer símbolo não numérico relevante
  s = s.replace(/\s/g, "").replace(/[^\d.,-]/g, "");

  // identifica separador decimal: o último '.' ou ',' presente
  const lastDot = s.lastIndexOf(".");
  const lastComma = s.lastIndexOf(",");
  let decimalSep = -1;
  if (lastDot > -1 || lastComma > -1) {
    decimalSep = Math.max(lastDot, lastComma);
  }

  if (decimalSep > -1) {
    const intPart = s.slice(0, decimalSep).replace(/[.,]/g, "");
    const fracPart = s.slice(decimalSep + 1).replace(/[.,]/g, "");
    s = `${intPart}.${fracPart}`;
  } else {
    // sem separador decimal: só remove milhares
    s = s.replace(/[.,]/g, "");
  }

  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
